import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { ReactComponent as Logo } from './../../graphics/images/leagueLogo.svg';

import styles from './SignIn.module.css';
import PrimaryButton from './../../partials/PrimaryButton';
import { signIn } from '../../api/signIn';
import { getUserPlayerInfo } from '../../api/getUserPlayerInfo';


function SignIn(props) {
  let history = useHistory();
  const { user, setUser } = props;

  const [userName, setUserName] = React.useState(null);
  const [userPass, setUserPass] = React.useState(null);
  const [isSigningIn, setIsSigningIn] = React.useState(false);

  const [errorMsg, setErrorMsg] = React.useState('');

  const handleUserName = e => {
    setUserName(e.target.value);
  };
  const handleUserPass = e => {
    setUserPass(e.target.value);
  };
  const handleSubmit = async () => {
    setIsSigningIn(true);
    setErrorMsg('');

    try {
      const res = await signIn(userName, userPass);


      if (res.error || res.hasError) {
        if (res.error.length > 0 && res.error[0] ===
          'Unable to log in with provided credentials.') {
          setErrorMsg('מספר הטלפון והססמה אינם תואמים');
        } else {
          setErrorMsg('אנא נסה שוב, אם התקלה ממשיכה צור קשר עם רכז הליגה');
        }
        setIsSigningIn(false);
        return;
      }

      const user = await getUserPlayerInfo();
      setUser(user);
    } catch (error) {
      setErrorMsg('מספר הטלפון והססמה אינם תואמים');
      setIsSigningIn(false);
    }
  };

  const handleClickSignup = () => {
    history.push('/signup/1');
  };

  const handleClickNewPass = () => {
    history.push('/newpassask');
  };

  React.useEffect(() => {
    if (user !== null && user != undefined) {
      history.push('/redirect');
    }
  }, [user, history]);

  return (<div className={styles.signIn}>
    <div className={styles.logo}>
      <Logo />
    </div>
    <h1>כניסה באמצעות סיסמה</h1>
    <form>
      <input type="number" placeholder="נייד" onChange={handleUserName} />
      <input type="password" placeholder="סיסמה*" onChange={handleUserPass} />
      <span className={styles.error}>{errorMsg}</span>
      <PrimaryButton
        text="התחברות"
        onClick={handleSubmit}
        loading={isSigningIn}
        disabled={isSigningIn || !userName || !userPass}
        size="large"
        type="button"
      />

    </form>

    <div className={styles.links}>
   <span className={styles.signupLink} onClick={handleClickNewPass}>
          שכחתי  סיסמה
        </span>

    </div>
    <br></br>
    <span className={styles.tryAnotherWay}>

          <p>
            התחברות מהירה באמצעות
          </p>

      <p style={{ marginTop: '5px' }}>
            <Link className={styles.tryAnotherWay}
                  to={'signin-sms'}> קוד לטלפון הנייד</Link>
          </p>
        </span>
  </div>);
}


export default SignIn;
